module.exports = __webpack_public_path__ + "img/version_bg.56e7e9c6.png";